export const HDN_MAX_DOCUMENT_BYTES = 35 * 1024 * 1024;

const CONVERTIBLE_EXTENSIONS = new Set([
	".heic",
	".webp",
	".png",
	".svg",
	".gif",
]);

/**
 * Check of een document te groot is voor HDN.
 * Afbeeldingen die geconverteerd worden (HEIC, WEBP, PNG, SVG, GIF → JPEG)
 * worden niet gecheckt — de backend checkt na conversie.
 */
export function isHdnNativeDocumentTooLarge(
	byteSize: number,
	filename: string,
) {
	const ext = filename.slice(filename.lastIndexOf(".")).toLowerCase();
	if (CONVERTIBLE_EXTENSIONS.has(ext)) return false;
	return byteSize > HDN_MAX_DOCUMENT_BYTES;
}
